// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__34XQ8","vLegacy":"SelectSecondary_vLegacy__3hSTD","error":"SelectSecondary_error__1M-we","disabled":"SelectSecondary_disabled__1x8HM"};